import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { FiBell, FiSearch, FiMenu, FiSun, FiMoon, FiLogOut } from 'react-icons/fi';
import logoOgp from '../assets/ogp-logo-blanc.png';

const Header = ({ onMenuClick = null }) => {
  const { user, logout } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);
  const [theme, setTheme] = useState(() => {
    if (typeof window === 'undefined') return 'light';
    return localStorage.getItem('theme') || 'light';
  });

  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark');
    localStorage.setItem('theme', theme);
  }, [theme]);

  const handleLogout = async () => {
    await logout();
  };

  return (
    <header className="header">
      <div className="header-left">
        {onMenuClick && (
          <button onClick={onMenuClick} className="header-icon-btn" aria-label="Menu">
            <FiMenu />
          </button>
        )}
        <div className="header-brand">
          <img src={logoOgp} alt="OGP" />
          <span>OGP IMMO</span>
        </div>

        <div className="header-search">
          <FiSearch className="header-search-icon" />
          <input
            type="text"
            placeholder="Rechercher des immobilisations..."
            className="header-search"
          />
        </div>
      </div>

      <div className="header-right">
        <button
          className="header-icon-btn"
          onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
          title={theme === 'dark' ? 'Mode clair' : 'Mode sombre'}
          aria-label="Toggle theme"
        >
          {theme === 'dark' ? <FiSun /> : <FiMoon />}
        </button>

        <button className="header-icon-btn" aria-label="Notifications">
          <FiBell />
        </button>

        <div className="dropdown">
          <button
            className="dropdown-toggle"
            onClick={() => setShowDropdown(!showDropdown)}
          >
            <div className="user-avatar" style={{ width: '32px', height: '32px' }}>
              {(user?.prenom || user?.firstName || '?').charAt(0).toUpperCase()}
            </div>
            <span>{user?.prenom || user?.firstName}</span>
          </button>

          {showDropdown && (
            <div className="dropdown-menu">
              <button disabled style={{ color: 'var(--gn-muted)', cursor: 'default' }}>
                {user?.email}
              </button>
              <div className="dropdown-divider"></div>
              <button onClick={handleLogout}>
                <FiLogOut style={{ marginRight: 6, verticalAlign: 'middle' }} />
                Déconnexion
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
